const host = process.env.REACT_APP_HOST_SERVER;
const API_BASE = host ? `http://${host}/api` : `/api`;

export function authFetch(path, options = {}) {
  const token = localStorage.getItem("token");
  const headers = {
    "Content-Type": "application/json",
    ...(options.headers || {}),
  };
  if (token) headers["Authorization"] = `Bearer ${token}`;
  return fetch(`${API_BASE}${path}`, { ...options, headers });
}

export { API_BASE };

